export default function Pagination({ currentPage, totalItems, pageSize, onPageChange, onPageSizeChange }) {
  const totalPages = Math.ceil(totalItems / pageSize);
  if (totalPages <= 1) return null;

  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", borderTop:"1px solid #f3f4f6", flexWrap:"wrap", gap:8 }}>
      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
        <span style={{ fontSize:12, color:"#6b7280" }}>Rows per page:</span>
        <select value={pageSize} onChange={(e) => onPageSizeChange(parseInt(e.target.value))}
          style={{ padding:"3px 6px", borderRadius:5, border:"1px solid #d1d5db", fontSize:12, fontFamily:"inherit" }}>
          {[25, 50, 100, 250].map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <span style={{ fontSize:12, color:"#6b7280" }}>
          Showing {((currentPage-1)*pageSize)+1}–{Math.min(currentPage*pageSize, totalItems)} of {totalItems}
        </span>
      </div>
      <div style={{ display:"flex", gap:4 }}>
        {[
          { label:"«", page:1,              disabled:currentPage===1 },
          { label:"‹", page:currentPage-1,  disabled:currentPage===1 },
          { label:currentPage, page:currentPage, disabled:true, active:true },
          { label:"›", page:currentPage+1,  disabled:currentPage===totalPages },
          { label:"»", page:totalPages,      disabled:currentPage===totalPages },
        ].map((btn, i) => (
          <button key={i} onClick={() => !btn.disabled && !btn.active && onPageChange(btn.page)}
            disabled={btn.disabled}
            style={{ width:32, height:32, borderRadius:6, border:"1px solid #d1d5db", background:btn.active?"#F47920":"#fff", color:btn.active?"#fff":btn.disabled?"#d1d5db":"#374151", cursor:btn.disabled||btn.active?"default":"pointer", fontFamily:"inherit", fontSize:13, fontWeight:btn.active?700:400 }}>
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
}
